import { PlayerClassType } from "../../enum/PlayerClassType";
import { MetersToUnits, toPixels } from "../../util";
import Player from "../Player";
import PlayerClass from "../PlayerClass";
import Gun from "../Gun";
import HealingField from "../abilities/healer/HealingField";
import EnergyTransfer from "../abilities/healer/EnergyTransfer";
import ShieldBurst from "../abilities/healer/EmergencyShieldBurst";
import RepairBeam from "../guns/healer/RepairBeam";
import PulseBlaster from "../guns/healer/PulseBlaster";

export default class Healer extends PlayerClass {

    constructor(player: Player) {
        super(PlayerClassType.Healer, player, new PulseBlaster(player), new RepairBeam(player));
        this.player.hp = this.player.maxHp = 700;
        this.player.energy = this.player.maxEnergy = 110;
        this.player.accelerationForce = toPixels(MetersToUnits(100));
        this.player.size = 8;

        this.abilities = [
            new HealingField(this.player),
            new EnergyTransfer(this.player),
            new ShieldBurst(this.player)
        ];
    }

    Draw(color: string): void {
        this.ctx.strokeStyle = color;
        this.ctx.fillStyle = color + "55";
        this.ctx.lineWidth = 1;

        //draw player
        const p1 = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size));
        const p2 = this.player.transform.position.add(this.player.transform.right.rotate(Math.PI/4).scale(this.player.size));
        const p3 = this.player.transform.position.add(this.player.transform.back.scale(this.player.size/2));
        const p4 = this.player.transform.position.add(this.player.transform.left.rotate(-Math.PI/4).scale(this.player.size));

        this.player.engine.fillShape(p1, p2, p3, p4);
        this.player.engine.strokeShape(p1, p2, p3, p4);
        //

        super.Draw(color);
    }

}